var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavViviendasWhite = function SvgNavViviendasWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nav_viviendas_white_svg__Capa_2",
    viewBox: "0 0 32.79 32.79"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "nav_viviendas_white_svg__Capa_1-2",
    d: "M32.57 15.59c-.29.29-.77.29-1.06 0l-1.69-1.7v15.66c0 1.79-1.46 3.25-3.25 3.25h-5.04l-.03-7.77-.02-.17c-.65-2.78-3.02-4.03-5.07-4.03s-4.43 1.25-5.07 4.03l-.05 7.94H6.24c-1.79 0-3.25-1.46-3.25-3.25V13.89l-1.69 1.7c-.29.29-.77.3-1.06 0a.745.745 0 0 1 0-1.06L10.95 3.72C13.41 1.24 14.65 0 16.4 0s2.99 1.24 5.45 3.72l10.73 10.81c.29.29.29.77 0 1.06Z",
    fill: "#fff"
  })));
};
export default SvgNavViviendasWhite;